import script from "./LiabilityBusiness.vue?vue&type=script&setup=true&lang=js"
export * from "./LiabilityBusiness.vue?vue&type=script&setup=true&lang=js"

import "./LiabilityBusiness.vue?vue&type=style&index=0&id=572162da&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-572162da"]])

export default __exports__